export default __webpack_public_path__ + "static/media/mobile_sea.c0a66a21.png";